import {
    monthWithDayAndYearArray,
    shortMonthAndYearFormat,
    shortMonthYearAndDayFormat,
} from '../../helpers/dataFormatters';
import { terms } from '../constants';
import { COLOR_PRIMARY_GREEN, COLOR_SECONDARY_GREEN } from '../../../common/constants/colors';

export const useChart = (chartData) => {
    const options = {
        chart: {
            borderRadiusWhenStacked: 'last',
            toolbar: { show: false },
            stacked: true,
            offsetY: 10,
            animations: {
                enabled: false
            }
        },
        colors: [COLOR_SECONDARY_GREEN, COLOR_PRIMARY_GREEN],
        dataLabels: {
            enabled: true,
            style: {
                colors: ['#000000']
            },
            offsetY: -20,
            offsetX: -4,
            formatter: function (val) {
                if (val === 0) return '';
                return Math.abs(val);
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                borderRaidusApplication: 'end',
                borderRadiusWhenStacked: 'all',
                borderRadius: 0,
                dataLabels: {
                    position: 'top',
                    hideOverflowingLabels: false
                }
            }
        },
        xaxis: {
            categories: chartData?.map((month, index) => {
                if (index === 0)
                    return monthWithDayAndYearArray(shortMonthYearAndDayFormat(month.startDate));
                if (index === chartData.length - 1) {
                    const endDate = new Date(month.endDate);
                    endDate.setDate(endDate.getDate() - 1);
                    return monthWithDayAndYearArray(
                        shortMonthYearAndDayFormat(endDate.toISOString())
                    );
                }
                return shortMonthAndYearFormat(month.startDate).split(' ');
            }),
            offsetY: 15,
            axisTicks: { show: false },
            axisBorder: { show: false },
        },
        yaxis: { labels: { show: false } },
        legend: { show: false },
        stroke: {
            colors: ['transparent'],
            width: 5
        },
        grid: {
            yaxis: { lines: { show: false } },
            xaxis: { lines: { show: false } },
            padding: { bottom: 20 },
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return Math.abs(val);
                }
            },
            x: { show: false },
        },
        annotations: {
            yaxis: [
                {
                    y: 0,
                    strokeDashArray: 0,
                    borderColor: '#C2C2C2',
                    borderWidth: 1,
                    opacity: 1,
                    label: {
                        show: false
                    }
                }
            ]
        }
    };

    const getSeries = (chartData) => {
        return [
            {
                name: terms.gained,
                data: chartData?.map((month) => month.agentsGained) || []
            },
            {
                name: terms.lost,
                data: chartData?.map((month) => month.agentsLost * -1) || []
            }
        ];
    };

    const chartProps = {
        options,
        series: getSeries(chartData),
        type: 'bar',
        height: 390,
        width: '100%'
    };

    return chartProps;
};
